import type { ComponentType } from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps a page so each navigation gets a fresh mount (`location.key` changes per history entry).
 * Fixes stale UI when the URL updates but the previous screen appears to stay visible.
 */
export function RoutePage({ page: Page }: { page: ComponentType }) {
  const location = useLocation();
  return <Page key={location.key} />;
}
